import moment from 'mj-moment'

interface PurchaseModalEvent {
  event_sale_end_at?: string
  event_end_at?: string
  cant_buy_time?: boolean | number
}

interface PurchasePageEvent {
  sale_end_at?: string
  end_at?: string
}

interface Ticket {
  on_sale?: boolean
  adjust?: boolean
  status?: string
}

type EventObject = PurchaseModalEvent | PurchasePageEvent

function isPurchaseModalEvent(event: EventObject): event is PurchaseModalEvent {
  return 'event_sale_end_at' in event || 'event_end_at' in event
}

/**
 * Determines if purchase button should be disabled based on ticket and event state
 * Handles different event object structures between PurchaseModal and purchase pages
 */
export const shouldDisablePurchaseButton = (ticket: Ticket | null, event: EventObject | null): boolean => {
  if (!ticket || !event) return true

  // Handle different event object structures with type guards
  const saleEndAt = isPurchaseModalEvent(event) ? event.event_sale_end_at : event.sale_end_at
  const eventEndAt = isPurchaseModalEvent(event) ? event.event_end_at : event.end_at

  // Event timing checks
  if (saleEndAt && moment().diff(saleEndAt) > 0) return true
  if (eventEndAt && moment().diff(eventEndAt) > 0) return true

  // Ticket availability checks
  if (!ticket.on_sale) return true
  if (ticket.adjust) return true
  if (ticket.status === 'sold_out') return true

  // Lottery status checks
  if (ticket.status === 'lottery_wating' || ticket.status === 'finish_lottery') return true

  return false
}
